"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("../types");
function calcTooltipCenterX(tooltipReferenceOffsetX, tooltipReferenceWidth) {
    return tooltipReferenceOffsetX + tooltipReferenceWidth / 2;
}
function getTooltipPositionByReferenceElement(tooltipReferenceElement, tooltipContainerElement, tooltipCenterXfn) {
    if (tooltipCenterXfn === void 0) { tooltipCenterXfn = calcTooltipCenterX; }
    var tooltipReferenceRect = tooltipReferenceElement.getBoundingClientRect();
    var tooltipContainerRect = tooltipContainerElement.getBoundingClientRect();
    var tooltipPlacement = tooltipReferenceRect.top > tooltipContainerRect.top
        ? types_1.TooltipPositionPlacement.BOTTOM
        : types_1.TooltipPositionPlacement.TOP;
    var tooltipReferenceOffsetX = tooltipReferenceRect.left - tooltipContainerRect.left;
    var tooltipCenterX = tooltipCenterXfn(tooltipReferenceOffsetX, tooltipReferenceRect.width);
    return { placement: tooltipPlacement, x: tooltipCenterX };
}
exports.default = getTooltipPositionByReferenceElement;
//# sourceMappingURL=getTooltipPositionByReferenceElement.js.map